import { FETCH_SIZE_PREFERENCES_SUCCESS } from '../constants/ActionTypes'

export default function sizePreferences(state = undefined, action) {
    switch (action.type) {
        case FETCH_SIZE_PREFERENCES_SUCCESS:
            return action.payload

        default:
            return state
    }
}
